const menuTriggers = '[data-diy-global-menu]';
const productMenuHoverArea = '[data-diy-products-nav]';
const productMenuTriggers = '[data-diy-products-trigger]';
const productMenuSelector = '[data-diy-products-mega]';
const productCloseSelector = '[data-diy-products-close]';
const drawerSelectors = [
  '[data-dfm-menu-open]',
  '.menu-drawer-container summary',
  'summary.header__icon--menu',
  '[ref="headerDrawerContainer"] summary'
];
const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
let closeMenuTimer;

const getProductMenu = () => document.querySelector(productMenuSelector);
const getProductMenuButtons = () => document.querySelectorAll(`${productMenuTriggers}, ${menuTriggers}`);
const isProductMenuArea = (target) => target?.closest?.(`${productMenuHoverArea}, ${productMenuTriggers}, ${productMenuSelector}`);

const setProductMenuOpen = (open) => {
  const productMenu = getProductMenu();
  if (!productMenu) return;
  window.clearTimeout(closeMenuTimer);
  productMenu.hidden = false;
  productMenu.dataset.state = open ? 'open' : 'closed';
  document.documentElement.classList.toggle('diy-products-mega-is-open', open);
  getProductMenuButtons().forEach((button) => button.setAttribute('aria-expanded', String(open)));
  document.dispatchEvent(new CustomEvent('diy:products-mega-toggle', { detail: { open } }));
  if (!open) productMenu.hidden = true;
};

const openProductMenu = () => setProductMenuOpen(true);
const closeProductMenu = () => setProductMenuOpen(false);
const toggleProductMenu = () => {
  const productMenu = getProductMenu();
  if (!productMenu) return false;
  setProductMenuOpen(productMenu.dataset.state !== 'open');
  return true;
};
const scheduleProductMenuClose = () => {
  if (!hoverQuery.matches) return;
  window.clearTimeout(closeMenuTimer);
  closeMenuTimer = window.setTimeout(closeProductMenu, 140);
};
const openFallbackDrawer = () => {
  for (const selector of drawerSelectors) {
    const target = document.querySelector(selector);
    if (target) { target.click(); break; }
  }
};

const isSecondaryCollectionPage = () => /^\/collections\/[^/]+\/?$/.test(window.location.pathname)
  && window.location.pathname !== '/collections/all';

const normalizeVistaprintDetailPages = () => {
  if (!isSecondaryCollectionPage()) return;

  document.querySelectorAll('[data-diy-carousel-track]').forEach((track) => {
    if (!track.dataset.diyInitialAligned) {
      track.scrollLeft = 0;
      track.dataset.diyInitialAligned = 'true';
    }
  });

  const noisy = /(^|: )maroon|fleece lined|top \+ pants|pants set|set colour|colour block set|reflective stripe|^indigo$|^khaki$|^beige$|^maroon \(solid\)$/i;
  document.querySelectorAll('.diy-category-page--collection-listing .diy-plp-filter-group__swatches label').forEach((node) => {
    const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || !noisy.test(text)) return;
    node.classList.add('diy-filter-noisy-option');
    node.closest('li, .diy-plp-filter-option, [role="option"]')?.classList.add('diy-filter-noisy-option');
  });

  document.querySelectorAll('.diy-category-page--collection-listing .diy-category-page__subnav').forEach((node) => {
    node.hidden = true;
  });
};

window.addEventListener('DOMContentLoaded', normalizeVistaprintDetailPages);
window.addEventListener('load', normalizeVistaprintDetailPages);
document.addEventListener('shopify:section:load', normalizeVistaprintDetailPages);
window.setTimeout(normalizeVistaprintDetailPages, 250);
window.setTimeout(normalizeVistaprintDetailPages, 900);

document.addEventListener('mouseover', (event) => {
  if (!hoverQuery.matches) return;
  if (event.target.closest(productMenuHoverArea)) openProductMenu();
  if (event.target.closest(productMenuSelector)) window.clearTimeout(closeMenuTimer);
});
document.addEventListener('mouseout', (event) => {
  if (!hoverQuery.matches) return;
  if (isProductMenuArea(event.relatedTarget)) return;
  if (event.target.closest(productMenuHoverArea) || event.target.closest(productMenuSelector)) scheduleProductMenuClose();
});
document.addEventListener('focusin', (event) => {
  if (event.target.closest(productMenuHoverArea)) openProductMenu();
});
document.addEventListener('click', (event) => {
  const closeTrigger = event.target.closest(productCloseSelector);
  if (closeTrigger) { event.preventDefault(); closeProductMenu(); return; }
  const productTrigger = event.target.closest(productMenuTriggers);
  if (productTrigger) { event.preventDefault(); toggleProductMenu(); return; }
  const trigger = event.target.closest(menuTriggers);
  if (!trigger) return;
  event.preventDefault();
  if (getProductMenu()) { toggleProductMenu(); return; }
  openFallbackDrawer();
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeProductMenu();
});
